// @flow

import * as preact from 'preact';
import { useEffect, useRef } from 'preact/hooks';

let wpUrl = 'https://wp.stolaf.edu';
let wpDevUrl = 'https://wpdev.stolaf.edu';

export function getBaseUrl(location: Location = window.location) {
	let baseUrl = location.origin;

	if (baseUrl !== wpUrl && baseUrl !== wpDevUrl) {
		baseUrl = wpUrl;
	}

	return baseUrl;
}

export function ToolWrapper(props: {
	active: boolean,
	children: React$Node,
	heading: string,
}) {
	let { active, children, heading } = props;

	// focus the heading of a tool when it becomes active
	let headingRef = useRef(null);
	useEffect(() => {
		headingRef.current && headingRef.current.focus();
	}, [active]);

	return (
		<div
			className="tools-nav__container"
			role="tabpanel"
			aria-hidden={active ? 'false' : 'true'}
			style={{ display: active ? 'block' : 'none' }}
		>
			<h3 tabIndex="-1" className="u-visual-hide" ref={headingRef}>
				{heading}
			</h3>

			{children}
		</div>
	);
}

export function Loading() {
	return (
		<div className="loader">
			<p>Loading…</p>
		</div>
	);
}

function ErrorMessage({ error }: { error: Error }) {
	useEffect(() => {
		console.error(error);
	}, [error]);

	return (
		<div className="loader">
			<p>An error occurred. Please reload the page and try again.</p>
			<p>
				If the error continues to occur, please email
				<a href="mailto:webmaster@stolaf.edu">webmaster@stolaf.edu</a>
				with the following message: "${error.message}".
			</p>
		</div>
	);
}

export { ErrorMessage as Error };
